{
  "slug": "standard-deviation-explained",
  "title": "Standard Deviation in IQ Testing",
  "description": "Why a 15-point standard deviation describes spread and connects scores to percentiles.",
  "category": "IQ statistics",
  "sections": [
    {
      "heading": "Meaning",
      "paragraphs": [
        "Why a 15-point standard deviation describes spread and connects scores to percentiles.",
        "Interpretation depends on population, instrument, edition, year, sampling, language, and method."
      ]
    },
    {
      "heading": "Read charts carefully",
      "paragraphs": [
        "Check representativeness, uncertainty, exclusions, and whether values were measured or estimated. Decimal-heavy rankings are not automatically precise.",
        "Group averages have substantial overlap and cannot determine an individual."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Prefer transparent primary datasets and intervals. Avoid causal claims from correlation alone.",
        "For an individual, use appropriate age norms and technical documentation."
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "OECD — PISA data and methodology",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "Why a 15-point standard deviation describes spread and connects scores to percentiles. Content reviewed 18 July 2026."
}
